/**
 * Admin Audit Logs Route
 * Requires admin role to access
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import { AuditLogs } from '../../pages/Admin/AuditLogs';

export const Route = createFileRoute('/_authenticated/admin/audit-logs')({
  beforeLoad: ({ context }) => {
    // Check if user is admin
    const user = (context as any)?.user;
    if (user && user.role !== 'admin') {
      throw redirect({
        to: '/home',
      });
    }
  },
  component: AuditLogs,
});
